import axiosInstance from "../common/axiosInstance";

export interface UpdateProfileData {
  fullName?: string;
  mobileNumber?: string;
  department?: string;
  // Org Admin specific fields
  organizationName?: string;
  adminTitle?: string;
  // Org User specific fields
  firstName?: string;
  lastName?: string;
  employeeId?: string;
  supervisor?: string;
}

export interface UpdateOrgAdminProfileData {
  org_admin_name?: string;
  org_name?: string;
  org_admin_phone?: string;
}

export interface UpdateOrgUserProfileData {
  firstName?: string;
  lastName?: string;
  mobile?: string;
  employeeId?: string;
  supervisor?: string;
}

export interface ResetPasswordData {
  currentPassword: string;
  newPassword: string;
}

export interface UpdatePasswordData {
  current_password: string;
  new_password: string;
}

export const profileService = {
  // Legacy updateProfile method (keeping for backward compatibility)
  updateProfile: async (data: UpdateProfileData) => {
    const response = await axiosInstance.put(`/api/user/profile`, data);
    return response.data;
  },

  // New method for Org Admin profile updates
  updateOrgAdminProfile: async (data: UpdateOrgAdminProfileData) => {
    try {
      const response = await axiosInstance.put(`/api/tenant/me`, data);
      return response.data;
    } catch (error: any) {
      console.error("Org Admin profile update error:", error);
      throw {
        response: {
          data: {
            message:
              error.response?.data?.message ||
              "Failed to update org admin profile",
          },
        },
      };
    }
  },

  // New method for Org User profile updates
  updateOrgUserProfile: async (data: UpdateOrgUserProfileData) => {
    try {
      const response = await axiosInstance.put(`/api/orgUser/user`, data);
      return response.data;
    } catch (error: any) {
      console.error("Org User profile update error:", error);
      throw {
        response: {
          data: {
            message:
              error.response?.data?.message ||
              "Failed to update org user profile",
          },
        },
      };
    }
  },

  resetPassword: async (data: ResetPasswordData) => {
    const response = await axiosInstance.put(
      `/api/user/reset-password`,
      data
    );
    return response.data;
  },

  // New method for updating password for both orgAdmin and orgUser
  updatePassword: async (userId: string, data: ResetPasswordData) => {
    try {
      const response = await axiosInstance.put(
        `/api/tenant/password/${userId}`,
        {
          current_password: data.currentPassword,
          new_password: data.newPassword,
        }
      );
      return response.data;
    } catch (error: any) {
      console.error("Password update error:", error);
      throw {
        response: {
          data: {
            message:
              error.response?.data?.error ||
              error.response?.data?.message ||
              "Failed to update password",
          },
        },
      };
    }
  },

  getCurrentUser: async () => {
    const response = await axiosInstance.get(`/api/user/profile`);
    return response.data;
  },
};
